import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `MapaInstalacion`, method: 'GET', body: null, token: token})
}